export const enum PropertyCallTooltipViewStoreEvent {
  clickClose = 'clickClose',
}
